<template>
    <div class="lexicon content-view">
        <h2 class="fs-24 text-center fc-theme">{{topIntro[activeName].top}}</h2>
        <p class="subtitle text-center fs-14 fc-666">{{topIntro[activeName].intro}}</p>
        <top-price ref="topPriceRef" :code="activeName"></top-price>
        <el-tabs class="marginT-20" v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="TOP20w词库" name="tao20w">
                <lexicon v-if="activeName == 'tao20w'"></lexicon>
            </el-tab-pane>
            <!-- <el-tab-pane label="搜索下拉推荐词" name="taosuggest">
                <recommend v-if="activeName == 'taosuggest'" :price="pricePreMonth"></recommend>
            </el-tab-pane>
            <el-tab-pane label="淘宝号搜索词推荐" name="usertag">
                <taobao-tag v-if="activeName == 'usertag'" :price="pricePreMonth"></taobao-tag>
            </el-tab-pane> -->
        </el-tabs>
        <el-card v-if="activeName == 'tao20w'" class="box-card tip-card">
            <div slot="header" class="clearfix">
                <el-tabs v-model="activeTip">
                    <el-tab-pane label="Top20w热词"></el-tab-pane>
                </el-tabs>
            </div>
            <div>
                <div class="title marginT-10 fc-theme fs-18">功能介绍</div>
                <div class="content fs-14 fc-666">
                    1、提供官方最新的Top20w热词。Top20万热词是搜索量最好、曝光率最高的关键词组合，是商家迅速提升店铺流量的帮手。<br>
                    2、商家可在该词表中，找到对应商品类目，选择适合商品的关键词，修改对应的标题、商品介绍等对应文字，可快速进行引流。<br>
                    3、数据来源于淘宝直通车后台，安全高效。<br>
                    4、每两小时更新一次热词，保证数据的实时性。<br>
                    5、可用在商品的关键词优化、详情页，结合钻展、直通车等投放方式，快速提升店铺流量，事半功倍。<br>
                    6、了解市场行情，以便对商品推广做规划。<br>
                    7、接口合作请加微信{{getkfWx()}} 

                </div>
            </div>
        </el-card>
    </div>
</template>

<script>
const topIntro = {
    'tao20w': {
        top: '淘宝词库的分析',
        intro: '实时查询淘宝搜索下拉框选词是通过淘宝、天猫、手机淘宝搜索下拉框查询淘宝搜索指数高、流量高、转化率高的关键词'
    },
    'taosuggest' : {
        top: '搜索下拉推荐词',
        intro: '通过实时查询官方推荐的关联词，来选择需要做的搜索词',
    },
    'usertag' : {
        top: '淘宝号搜索词推荐',
        intro: '通过实时查询官方对指定淘宝号推荐的搜索词，获取到淘宝相关的标签',
    }
}
import { mapState } from 'vuex'
import lexicon from './lexicon'
import recommend from './recommend';
import taobaoTag from './taobaoTag';
export default {
    computed: {
        ...mapState(['userData', 'phone', 'configData'])
    },
    components: {
        lexicon,
        recommend,
        taobaoTag
    },
    data() {
        return {
            topIntro,
            pricePreMonth: {},
            activeTip: undefined,
            //activeName: this.$route.path == '/lexRecommend' ? 'taosuggest' : this.$route.path == '/lexTaobaoTag' ? 'usertag' : 'tao20w',
            activeName: 'tao20w',
        }
    },
    methods: {
        async priceLimit(name) {
            const data = await this.$fetch('/tool/apps/api-info', {name})
            if (data && data.data) {
                this.pricePreMonth = data.data
            }
        },
        handleClick(tab, event) {
            this.$nextTick(() => {
                this.$refs.topPriceRef.priceLimit()
            })
        }
    },
    mounted () {
        
    },
    watch: {
        '$route'(newValue, oldValue) {
            // this.activeName = this.$route.path == '/lexRecommend' ? 'taosuggest' : this.$route.path == '/lexTaobaoTag' ? 'usertag' : 'tao20w'
            this.activeName = 'tao20w'
            this.priceLimit(this.activeName)
        }
    },
}
</script>

<style lang="scss" scoped>

</style>
